import { z } from "zod/v4";

const VariationMetafieldDtoSchema = z.object({
  variationId: z.string(),
  price: z.string().optional(),
  currencyCode: z.string().optional(),
});

export type VariationMetafieldDto = z.infer<typeof VariationMetafieldDtoSchema>;
